<template>
  <v-container class="ml-3">
    <v-btn fab color="secondary" small @click="switchLocale('sv')">
      <v-img class="mx-2" height="18" width="18" src="@/assets/icons/Flag_of_Sweden.svg"/>
    </v-btn>
    <v-btn class="ml-2" fab color="secondary" small @click="switchLocale('en')">
      <v-img class="mx-2"  height="18" width="18" src="@/assets/icons/Flag_of_the_United_Kingdom.svg"/>
    </v-btn>
  </v-container>
</template>

<script>
import {mapActions} from 'vuex'

export default {
  name: 'LanguageSwitcher',

  methods: {
    ...mapActions('app',['switchLocale'])
  }
}
</script>

<style>

</style>